module.exports = __webpack_public_path__ + "img/google-plus.00542666.svg";